// Shared tokens for the dark table screens; were six copies, keep them here so they can't drift

export const headerCellSx = {
  backgroundColor: '#151d3b',
  color: '#8fa3d4',
  fontWeight: 700,
  fontSize: '13px',
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  borderBottom: '2px solid #2a3a6e',
  whiteSpace: 'nowrap',
};

// Zebra + touch sizing for a data row. Goes on <TableRow sx={dataRowSx}>.
export const dataRowSx = {
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#232a45',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#1a2036',
  },
  '& td, & th': {
    fontSize: '20px',
    padding: '14px 12px',
    borderBottom: '1px solid #2a3a6e',
    // digits line up down a column; no effect on text cells
    fontVariantNumeric: 'tabular-nums',
  },
};

// The leading time/date column, muted like the rest of the meta info
export const timeCellSx = {
  color: '#8fa3d4',
  fontWeight: 700,
};

// A Select's menu renders in a portal: without this the control is touch-sized but the list is not
export const touchMenuProps = {
  PaperProps: {
    sx: {
      backgroundColor: '#232a45',
      border: '1px solid #365ab8',
      // A finger needs the whole row, not a 36px default
      '& .MuiMenuItem-root': {
        color: '#e6eaf2',
        fontSize: '22px',
        minHeight: 72,
        paddingLeft: '20px',
        paddingRight: '20px',
      },
      '& .MuiMenuItem-root:hover': {
        backgroundColor: '#2a3a6e',
      },
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: '#365ab8',
      },
      '& .MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: '#365ab8',
      },
    },
  },
};
